import { render, staticRenderFns } from "./TransformEditComponents.vue?vue&type=template&id=ffa2cf20&"
import script from "./TransformEditComponents.vue?vue&type=script&lang=js&"
export * from "./TransformEditComponents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports